import { jsxs as u, jsx as e } from "react/jsx-runtime";
import { e as x } from "../../index-9f00b8a0.js";
function g({
  messages: t,
  chatName: r,
  sendMessage: s,
  minimizeChat: a,
  ChatHeader: i,
  MessageList: o,
  MessageRow: n,
  MessageAvatar: m,
  MessageBody: h,
  ChatInput: c,
  ConnectPrompt: d,
  WelcomeMessage: f
}) {
  const p = x();
  return /* @__PURE__ */ u("div", { className: "rt-chatContainer", children: [
    /* @__PURE__ */ e(i, { chatName: r, minimizeChat: () => a() }),
    /* @__PURE__ */ e(
      o,
      {
        messages: t,
        MessageRow: n,
        MessageBody: h,
        MessageAvatar: m,
        ConnectPrompt: d,
        WelcomeMessage: f
      }
    ),
    p && /* @__PURE__ */ e(c, { sendMessage: s })
  ] });
}
export {
  g as default
};
